import controller from './dashboard.controller';
import template from './dashboard.view.html';

let DashboardComponent = {
  template,
  controller,
  bindings : {
    shCtrl : '<'
  }
};

export default DashboardComponent;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/pay-zone/dashboard/dashboard.component.js
 **/